<template>
  <div :class="TPUB_WEB === '1'? 'pre-posted' : ''" class="product">
    <div v-if="TCOLL === 'F' && TCAT_GEN === 'OFFRE'">
      <div class="limited-stock">
        <span>{{$_('limited_stock').toUpperCase()}}</span>
      </div>
      <div class="special-offer">
        <span>{{$_('special_offer').toUpperCase()}}</span>
      </div>
    </div>
    <div v-else-if="TCOLL === 'F'">
      <div class="end-fo-series">
        <span>{{$_('end_of_series').toUpperCase()}}</span>
      </div>
      <div class="limited-stock">
        <span>{{$_('limited_stock').toUpperCase()}}</span>
      </div>
    </div>
    <div v-else-if="TCAT_GEN === 'OFFRE'">
      <div class="special-offer">
        <span>{{$_('special_offer').toUpperCase()}}</span>
      </div>
      <div class="limited-stock">
        <span>{{$_('limited_stock').toUpperCase()}}</span>
      </div>
    </div>
    <div class="product-img">
      <img :src="this.IMG" @error="handleImageError" />
    </div>
    <div class="product-meta">
      <span class="product-name">{{TMOD_DESC}}</span>
      <span class="product-reference">{{$_('reference')}} {{TMOD}}</span>
      <span class="product-reference">{{TCOMPO}}</span>
    </div>
  </div>
</template>

<script>
import ProductService from '@/modules/produit/services/productService';

export default {
  props: ["productinfo"],
  data() {
    return {
      TMOD_DESC: "",
      TMOD: "",
      TCAT_GEN: "", 
      IMG: "",
      TCOLL: "",
      TMOD_DESCM: "",
      TCOMPO: "",
      TPUB_WEB: ""
    };
  },
  created() {
    this.TMOD_DESC = this.$props.productinfo.TMOD_DESC;
    this.TMOD_DESCM = this.$props.productinfo.TMOD_DESCM;
    this.TCOLL = this.$props.productinfo.TCOLL;
    this.TMOD = this.$props.productinfo.TMOD;
    this.TCAT_GEN = this.$props.productinfo.TCAT_GEN;
    this.TCOMPO = this.$props.productinfo.TCOMPO;
    this.TPUB_WEB = this.$props.productinfo.TPUB_WEB;
  },
  mounted() {
    // On récupère l'image du produit
    ProductService.getFileProductImage(this.TMOD, 'p1-' + this.TMOD + '.jpg')
      .then(response => {
        const blob = response.data; // <-- ici le vrai blob devrait arriver

        if (!(blob instanceof Blob)) {
          throw new TypeError("Le fichier récupéré n'est pas un Blob");
        }

        // Retourner l'URL blob
        this.IMG = URL.createObjectURL(blob);
      })
      .catch(() => {
        // Si besoin, on affiche une image par défaut
        this.IMG = `${process.env.VUE_APP_API_URL}static/vignettes/non-disponible.jpg`;
      });
  },
  destroyed() {
    // On libère l'URL de l'image pour éviter les fuites de mémoire
    if (this.IMG && this.IMG.startsWith('blob:')) {
      URL.revokeObjectURL(this.IMG);
    }
  },
  methods: {
    handleImageError(event) {
      // Éviter les boucles infinies
      if (event.target.dataset.errorHandled === "true") {
        return;
      }

      // Marquer l'image comme traitée pour éviter les boucles
      event.target.dataset.errorHandled = "true";

      // URL de l'image par défaut
      const fallback = `${process.env.VUE_APP_API_URL}static/vignettes/non-disponible.jpg`;

      // Si c'est déjà l'image par défaut, on ne fait rien
      if (event.target.src.includes('non-disponible.jpg')) {
        return;
      }

      // On utilise directement l'image par défaut pour éviter les appels en boucle
      event.target.src = fallback;
    }
  }
};
</script>

<style scoped>
.product {
  border: solid 1px #e9e9e9;
  padding: 50px 50px 30px 50px;
  transition: all 0.3s;
  position: relative;
  max-width: 400px;
}

.product:hover {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.product-meta {
  margin-top: 30px;
}
.product-meta span {
  display: block;
  margin: 3px 0px;
}
.product-meta span.product-cat {
  color: #949494;
  font-size: var(--fz-sm);
  letter-spacing: 2px;
}
.product-meta span.product-name {
  color: #000;
  font-size: var(--fz-md);
}
.product-meta span.product-reference {
  color: #949494;
  font-size: var(--fz-md);
}
.favorite-product {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 20px;
}
.end-fo-series {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgb(240, 130, 12);
  padding: 6px 10px;
  display: flex;
}
.end-fo-series span {
  font-size: 0.6rem;
  color: #fff;
}
.special-offer {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #f00c33;
  padding: 6px 10px;
  display: flex;
}
.special-offer span {
  font-size: 0.6rem;
  color: #fff;
}
.limited-stock {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f00c33;
  padding: 6px 10px;
  display: flex;
}
.limited-stock span {
  font-size: 0.6rem;
  color: #fff;
}
.product.pre-posted:after {
  content: "";
  background-color: rgba(0, 0, 0, 0.204);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

@media (min-width: 800px) {
  .product {
    padding: 50px 49px 30px 49px;
  }
}

@media (min-width: 1024px) {
  .product {
    padding: 50px 19px 30px 20px;
  }
}
</style>